export const environment = {
  production: false,
  environment: 'testing',
  client: 'organization-app',
  apiUrl: 'https://api.testing.smartparking.jjames.eu',
  // Base URL of the parker app; the Easypass invitation link is `${parkerUrl}/easypass/redeem/<token>`.
  parkerUrl: 'https://parker.testing.jjames.eu',
  auth: {
    authority: 'https://auth.testing.smartparking.jjames.eu',
    realm: 'jjames',
    clientId: 'jjames-organization-frontend',
    clientBackend: 'jjames-backend'
  }
};
